<template>
  <v-dialog v-model="dialogOpen" max-width="35rem">
    <v-card elevation="0" class="mt-0">
      <v-simple-table class="mt-0">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                <v-icon color="warning">mdi-trophy</v-icon>
              </th>
              <th class="text-left">Leaderboard</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in compRanks" :key="item.name">
              <td>
                <v-avatar size="30" class="mr-2" v-if="item.profile">
                  <img :src="item.profile" alt="Profile Picture" />
                </v-avatar>
                <v-avatar v-else size="30" class="mr-2">
                  <img
                    src="../../assets/Male Avatar.png"
                    alt="Profile Picture"
                  />
                </v-avatar>
                {{ item.name }}
              </td>
              <td>{{ item.rank }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions class="mt-0">
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  BASE_URL,
  QUIZ_COMPETITION_COMP_LEADERBOARD,
} from "@/common/apiEndpoints";
import { getAxiosOptions } from "@/common/utility";
import { GET_TOKEN, GET_PARAMS_VALUE } from "@/store/getters";
import { SET_OVERLAY_VALUE } from "@/store/mutations";
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialogOpen: false,
      compRanks: [],
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
      paramsValue: `schoolModule/${GET_PARAMS_VALUE}`,
    }),
  },
  methods: {
    ...mapMutations({
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
    }),

    openLeaderboard() {
      const url = QUIZ_COMPETITION_COMP_LEADERBOARD;
      const payload = { compId: this.paramsValue.quizCompId };
      this.setOverlayValue(true);
      return axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          const leaderboard = res.data.leaderboard;
          this.compRanks = [];

          leaderboard.forEach((item, index) => {
            if (index < 10) {
              this.compRanks.push({
                name: `${item.firstName} ${item.lastName}`,
                profile: item.profilePic,
                rank: item.rank,
                userId: item.userId,
              });
            }
          });
          this.dialogOpen = true;
          this.setOverlayValue(false);
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.errorMessage || error.message;
          this.setOverlayValue(false);
          throw new Error(errorMessage);
        });
    },

    closeDialog() {
      this.dialogOpen = false;
    },
  },
};
</script>
